import {configureStore} from "@reduxjs/toolkit";
import {TypedUseSelectorHook, useDispatch, useSelector} from "react-redux";
import { setAutoFreeze } from "immer";
import subscriptionTableSlice from "./subscriptionTableState/subscriptionTableSlice.ts";
import userSliceV2 from "./UserStatesV2/userSliceV2.ts";
import ModalSlice from "./ModalSlice/ModalSlice.ts";
import ArbitrarySlice from "./ArbitrarySlice/ArbitratySlice.ts";
import LiveSubscriptionSlice from "./LiveSubscriptionSlice/LiveSubscriptionSlice.ts"
import OrderStatsSlice from "./OrderState/OrderStatsSlice.ts";
import BusinessLeadsSlice from "./BusinessLeadsSlice/BusinessLeadsSlice.tsx"
import PastCampaignSlice from "./PastCampaignSlice/PastCampaignSlice.ts"
import ExportsDataSlice from "./ExportsDataSlice/ExportsDataSlice.tsx"
import zoomSlice from "./ZoomSlice/zoomSlice.ts"
import googleMeetSlice from "./GoogleMeetSlice/googleMeetSlice.ts"
import {FLAVOR} from "../Config/firebase.ts"

// Disable Immer's auto-freeze to prevent cross-origin frame access errors
// This is necessary because freezing recursively accesses object properties,
// which fails on cross-origin window/iframe references
setAutoFreeze(false);

export const store = configureStore(
    {
        reducer: {
            userSliceV2,
            OrderStatsSlice,
            subscriptionTableSlice,
            ModalSlice,
            ArbitrarySlice,
            LiveSubscriptionSlice,
            PastCampaignSlice,
            BusinessLeadsSlice,
            ExportsDataSlice,
            zoomSlice,
            googleMeetSlice
        },
        devTools: true || FLAVOR === "DEVELOPMENT",
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                serializableCheck: false,
                immutableCheck: false,
            }),
    }
)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch

export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector